/**
 * Super-admin-only auth operations (Express API).
 */

import { API_BASE_URL, request } from '@/lib/apiClient'

/** Force-set another user's password (updates auth.users, revokes their sessions). Super admins only. */
export async function superadminForceResetPassword(targetEmail: string, newPassword: string): Promise<void> {
  const { error } = await request<{ success: boolean }>('POST', '/api/auth/superadmin/force-reset-password', {
    target_email: targetEmail.trim(),
    new_password: newPassword,
  })
  if (!error) return
  const msg = error.message
  if (msg === 'HTTP 404' || /404/.test(msg)) {
    if (!API_BASE_URL) {
      throw new Error(
        'This frontend build has no VITE_API_URL, so requests go to the web host (e.g. Vercel) instead of your Express API. Set VITE_API_URL to your API origin (e.g. https://api.example.com) in the hosting env, rebuild, and redeploy.'
      )
    }
    throw new Error(
      'Force reset returned 404. Redeploy the API with the latest auth routes, or fix the reverse proxy so /api/auth/… is forwarded to Node with the /api prefix intact.'
    )
  }
  throw new Error(msg)
}
